'use client';

import { useDrawer, useModal } from '@cat-ecom/pcc-components';
import {
  createContext,
  useContext,
  FC,
  PropsWithChildren,
  useMemo,
  useState,
  Dispatch,
  SetStateAction
} from 'react';

type Modal = ReturnType<typeof useModal>;
type Drawer = ReturnType<typeof useDrawer>;
type DrawersContext = {
  isLoading: boolean;
  showLoader: Dispatch<SetStateAction<boolean>>;
  associatedDealerModal: Modal;
  associatedDealerDrawer: Drawer;
  searchResultsDrawer: Drawer;
  selectCustomerDrawer: Drawer;
};

//Create context
const AssociatedDealerContext = createContext<DrawersContext>(null);

export const useAssociatedDealer = () => useContext(AssociatedDealerContext);

// create Provider
export const AssociatedDealerProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const associatedDealerModal = useModal({ isRequired: true, size: 'md' });
  const associatedDealerDrawer = useDrawer(); // Main drawer; either for select-customer or dealer-search drawer
  const searchResultsDrawer = useDrawer();
  const selectCustomerDrawer = useDrawer();

  const context = useMemo(() => {
    return {
      isLoading,
      showLoader: setIsLoading,
      associatedDealerModal,
      associatedDealerDrawer,
      searchResultsDrawer,
      selectCustomerDrawer
    };
  }, [
    isLoading,
    setIsLoading,
    associatedDealerModal,
    associatedDealerDrawer,
    searchResultsDrawer,
    selectCustomerDrawer
  ]);

  return (
    <AssociatedDealerContext.Provider value={context}>
      {children}
    </AssociatedDealerContext.Provider>
  );
};
